import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Text } from 'foundations-components/components/Text';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import ManageVariantsLink from 'personalization-lib/components/shared/links/ManageVariantsLink';
import VariantsModalBody from 'personalization-lib/components/variantsModal/VariantsModalBody';
import useVariants from 'personalization-lib/hooks/useVariants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VariantsModal = ({
  strategyId,
  onClose,
  onError
}) => {
  const {
    variants,
    loading,
    error
  } = useVariants(strategyId, onError);
  return /*#__PURE__*/_jsxs(Modal, {
    width: "550px",
    "data-test-id": "variants-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "personalizationLib.variantsModal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(VariantsModalBody, {
        variants: variants.slice(0, -1),
        loading: loading,
        error: error
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: !(error || loading) && /*#__PURE__*/_jsx(ManageVariantsLink, {
        strategyId: strategyId
      })
    })]
  });
};
export default VariantsModal;